<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Temperatura do orçamento"
    type-modal="change_quotation_priority"
  >
    <div class="modal-content__main">
      <d-form @submit="updatePriority()">

        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Temperatura</label>
            <d-select v-model="model.priority_id" :options="options"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        class="btn btn-sm btn-secondary mr-3"
        @click="close()"
      >Cancelar</d-button>
      <d-button
        type="button"
        class="btn btn-sm btn-primary"
        @click="updatePriority()"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { _OPEN_MODAL_ } from '../QuotationModel';

export default {
  name: 'change-quotation-priority',
  data() {
    return {
      loading: false,
      model: {
        priority_id: null,
      },
      quotation: { id: null },
    };
  },
  components: {
    ModalTemplate,
  },
  computed: {
    options() {
      const { priorities } = this.$store.state.quotation;
      if (priorities && priorities.length) {
        return priorities;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getPriorities',
    ]),
    close() {
      this.setToggle({ type: 'change_quotation_priority', bool: false });
    },
    getOptions() {
      if (!this.$store.state.quotation.priorities) {
        this.getPriorities();
      }
    },
    updatePriority() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updatePriority(this.quotation.id, this.model)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', { page: 1 });
          this.activeAlert({ message: 'Orçamento atualizado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    this.getOptions();
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'change_quotation_priority') {
        this.quotation = quotation;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
